import { atom } from "recoil";

export const activeKeyAtom = atom<string>({
  key: "activeKey",
  default: "0",
});
